/** Format an ISO timestamp as a short local date, e.g. "Oct 3, 2026". */
export function shortDate(iso: string): string {
  return new Date(iso).toLocaleDateString(undefined, {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
}
